import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../utils/scrollToSection";

/**
 * Sur la landing (/), scroll vers la section indiquée par le hash (#contact, etc.).
 */
export function useScrollToHash(enabled: boolean) {
  const location = useLocation();

  useEffect(() => {
    if (!enabled || !location.hash) return;

    const sectionId = location.hash.replace(/^#/, "");
    if (!sectionId) return;

    scrollToSection(sectionId);
  }, [enabled, location.pathname, location.hash]);
}
